import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({
  type, size = null, notSpaced = false, color = 'default', className = '', transform = '',
}) => {
  const extraClassNames = (notSpaced ? 'is-not-spaced' : '') + (color ? ` is-${color}` : '') + (size ? ` fa-${size}` : '')

  let types = ''
  if (typeof type === 'string') {
    types = `fa fa-${type}`
  } else if (type && type.length > 1) {
    types = `${type[0]} fa-${type[1]}`
  }

  return (
    <i
      className={`svg-inline--fa ${types} ${className} ${extraClassNames}`}
      data-fa-transform={transform}
    />
  )
}

Icon.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  size: PropTypes.string,
  notSpaced: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  transform: PropTypes.string,
}

export default Icon
